import React, { useState } from "react";
import PropTypes from "prop-types";

import { useTranslation } from "@common/hooks/translation";

import NumericInput from "@common/components/numericInput";
import { payWithdrawalRequest } from "@app/dev/helpers/clientTransaction";
import ToastWrapper from "@common/helpers/toastWrapper";
import WithdrawRequestItem from "./requestItem";

const WithdrawPayRequest = ({ request, onBack, onNext }) => {
	const t = useTranslation();
	const [passkey, setPasskey] = useState("");

	const withdraw = async () => {
		const { isSuccess, errorMessage } = await payWithdrawalRequest(request.Id, +passkey);

		if (!isSuccess) return ToastWrapper("error", errorMessage);

		onNext();
	};

	return (
		<div className="ct-form">
			<h3 className="ct-form-title">{t("Withdraw")}</h3>
			<p className="ct-form-subtitle">{t("Enter passkey to withdraw")}</p>

			<div className="ct-form-withdraw-requests">
				<WithdrawRequestItem key={request.Id} data={request} />
			</div>

			<div className="ct-input-wrapper">
				<NumericInput value={passkey} onChange={setPasskey} placeholder={t("Passkey")} />
			</div>

			<div className="ct-form-buttons">
				<button onClick={onBack}>{t("Back")}</button>
				<button className="ct-form-submit-btn" onClick={withdraw} disabled={!passkey}>
					{t("Withdraw")}
				</button>
			</div>
		</div>
	);
};

WithdrawPayRequest.propTypes = {
	client: PropTypes.object.isRequired,
	request: PropTypes.object.isRequired,
	onBack: PropTypes.func,
	onNext: PropTypes.func,
};

export default WithdrawPayRequest;
